(function() {
  var currentUrl = window.location.href;
  var currentPath = window.location.pathname.toLowerCase();

  // Redirect specific "bad" full URL with multiple slashes
  if (currentUrl === "https://sisuwellnessco.com/////////") {
    window.location.replace("https://sisuwellnessco.com/");
    return; // stop further checks
  }

  // Normalize ANY multiple slashes (except the https:// part)
  if (currentUrl.match(/\/\/{2,}/)) {
    var cleanedUrl = currentUrl.replace(/\/{2,}/g, '/');
    cleanedUrl = cleanedUrl.replace('https:/', 'https://');
    if (cleanedUrl !== currentUrl) {
      window.location.replace(cleanedUrl);
      return;
    }
  }

  // Redirect unwanted PHP/HTML pages
  var redirects = {
    "/index.php": "/",
    "/index.html": "/",
    "/home.php": "/",
    "/home.html": "/"
  };

  if (redirects[currentPath]) {
    window.location.replace("https://sisuwellnessco.com" + redirects[currentPath]);
  }
})();
